export type AudioVizConfig = {
  color: string;
};

export const defaultConfig: AudioVizConfig = {
  color: "#4b3bff",
};

export default defaultConfig;
